import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    title: "Titolare del trattamento",
    body: "Il titolare del trattamento dei dati personali è la Dott.ssa Valentina Maritato, mediatrice familiare, con studio in Via Claudio Crea, 25 — 88900 Crotone (KR). Contatti: email valentina.maritato85@gmail.com · PEC valentina.maritato@pec.it · tel. +39 329 633 0445.",
  },
  {
    title: "Dati raccolti",
    body: "Attraverso il modulo contatti di questo sito vengono raccolti: nome e cognome, indirizzo email, numero di telefono (facoltativo), tipo di richiesta e testo del messaggio. Non vengono raccolti dati particolari (sensibili) tramite il sito: ti chiediamo di non inserire nel messaggio informazioni su salute, procedimenti giudiziari o minori più del necessario.",
  },
  {
    title: "Finalità e base giuridica",
    body: "I dati vengono trattati esclusivamente per ricontattarti e fornirti le informazioni richieste sulla mediazione familiare, e — se lo vorrai — per fissare un colloquio. La base giuridica è il tuo consenso (art. 6, par. 1, lett. a del Regolamento UE 2016/679 — GDPR), espresso con la casella di consenso nel modulo.",
  },
  {
    title: "Conservazione e comunicazione",
    body: "Le richieste sono conservate in un'area riservata protetta da password, accessibile solo alla titolare, per il tempo necessario a gestire la richiesta e comunque non oltre 24 mesi. I dati non vengono ceduti, venduti o comunicati a terzi, salvo obblighi di legge.",
  },
  {
    title: "I tuoi diritti",
    body: "In qualità di interessata/o puoi esercitare in qualsiasi momento i diritti previsti dagli articoli 15–22 del GDPR: accesso, rettifica, cancellazione, limitazione, portabilità, opposizione e revoca del consenso. Puoi farlo scrivendo a valentina.maritato85@gmail.com o alla PEC valentina.maritato@pec.it. Hai inoltre diritto di reclamo al Garante per la protezione dei dati personali (www.garanteprivacy.it).",
  },
  {
    title: "Cookie",
    body: "Questo sito non utilizza cookie di profilazione propri. Possono essere presenti cookie tecnici necessari al funzionamento e strumenti di analisi anonima dell'utilizzo del sito.",
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-paper" data-testid="privacy-page">
      <header className="border-b border-ink/10 bg-paper/90 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-[72px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="privacy-logo">
            <img src="/assets/logo.png" alt="Oltre il Conflitto" className="h-11 w-11 rounded-full ring-1 ring-ink/10 object-cover" />
            <span className="font-serif font-semibold text-ink tracking-wide text-sm sm:text-base">OLTRE IL CONFLITTO</span>
          </Link>
          <Link to="/" data-testid="privacy-back-home"
            className="inline-flex items-center gap-2 text-sm font-semibold text-ink hover:text-golddeep transition-colors">
            <ArrowLeft size={15} /> Torna al sito
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
        <p className="overline-tag mb-4">Documento legale</p>
        <h1 className="font-serif font-semibold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-tight">
          Informativa sulla privacy
        </h1>
        <p className="mt-5 text-base text-mist leading-relaxed max-w-2xl">
          Informativa resa ai sensi dell'art. 13 del Regolamento (UE) 2016/679 (GDPR) a chi
          utilizza il modulo contatti di questo sito. Ultimo aggiornamento: settembre 2026.
        </p>

        <div className="mt-12 flex flex-col gap-8">
          {SECTIONS.map((s, i) => (
            <section key={s.title} className="bg-white border border-ink/10 rounded-2xl p-6 sm:p-8" data-testid={`privacy-section-${i}`}>
              <h2 className="font-serif font-semibold text-ink text-xl sm:text-2xl">{s.title}</h2>
              <p className="mt-3 text-sm sm:text-base text-mist leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </main>

      <footer className="bg-night text-paper/50 text-xs py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p>© 2026 Dott.ssa Valentina Maritato — Mediazione Familiare, Crotone.</p>
          <Link to="/" className="hover:text-gold transition-colors" data-testid="privacy-footer-home">oltreilconflitto — home</Link>
        </div>
      </footer>
    </div>
  );
}
